export default function email(state={}, action) {
	switch (action.type) {
		case 'INIT_EMAIL':
			return {
				...state,
				status: 0,
				email: ''
			};
		case 'SAVE_EMAIL':
			return {
				...state,
				status: action.data.status,
				email: (action.data.status === 0) ? action.data.next_action.verified_info.email : null
			};
		default:
			break;
	}
	return state;
}


// WEBPACK FOOTER //
// ./app/reducers/email.js